import Form from "../components/Form";
import "../styles/LandingPage.css";
import logo from "../media/Gold-01.png";
import logoDark from "../media/Black-01.png";
import { Slide } from "react-awesome-reveal";

function LandingPage({ darkMode }) {
  return (
    <div className="landing__page">
      <div className="landing__page__inner">
        <div className="heading__section">
          <div className="heading__container">
            <h1>
              <span>The best</span> way to <br></br>predict the{" "}
              <span>FUTURE</span> is to create it
            </h1>
            <h3>
              Web Development Solutions <span>for everyone</span>
            </h3>
            <div className="contact__btn">
              <a href="#form">
                <button className={darkMode === "dark" ? "" : "btn__dark"}>
                  <p>Contact Us</p>
                </button>
              </a>
            </div>
          </div>
        </div>
        <div className="logo__section">
          <Slide triggerOnce direction="up">
            <img
              className="logo"
              alt=""
              src={darkMode === "dark" ? logo : logoDark}
            ></img>
          </Slide>
        </div>
      </div>

      <div className="contact__section">
        <div className="contact__link__group">
          <div className="contact__heading">
            <h1>ARTEMIS</h1>
            <h1>
              <span>DEVELOPMENT</span>
            </h1>
          </div>
        </div>
        <Form/>
      </div>
    </div>
  );
}

export default LandingPage;
